import { PatientCreateEconsultRequest } from "@shared/dtos/requests/econsultRequests.dto"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const addByPatient = (req: PatientCreateEconsultRequest): Promise<void> => {
  return axiosPatient({
    url: "/patient/econsults",
    method: "post",
    data: {
      pageId: req.pageId,
      subject: req.subject,
      message: req.message,
      uploadReferences: req.uploadReferences,
      ...(req.platoSessionId ? { platoSessionId: req.platoSessionId } : {}),
    },
  }).then(() => undefined)
}
